import React, { useState } from 'react';

const PlanFeatureMatrix = ({
  plans,
  featureMatrix,
  onToggle,
  onAddFeature,
  onRemoveFeature
}) => {
  const [newFeature, setNewFeature] = useState('');
  const featureNames = [...new Set(
    plans.flatMap((plan) => Object.keys(featureMatrix[plan.key] || {}))
  )].sort((first, second) => first.localeCompare(second));

  const addFeature = () => {
    const feature = newFeature.trim();
    if (!feature || featureNames.some((name) => name.toLowerCase() === feature.toLowerCase())) return;
    onAddFeature(feature);
    setNewFeature('');
  };

  return (
    <div>
      <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
        <table className="w-full min-w-[640px] border-separate border-spacing-0 text-left">
          <thead>
            <tr>
              <th className="sticky left-0 z-10 border-b border-slate-200 bg-slate-50 p-3 text-xs font-black uppercase tracking-wider text-slate-500">
                Features
              </th>
              {plans.map((plan) => (
                <th key={plan.key} className="border-b border-l border-slate-200 bg-slate-50 p-3 text-xs font-black text-slate-700">
                  {plan.name || 'New plan'}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {featureNames.length ? featureNames.map((feature) => (
              <tr key={feature}>
                <th scope="row" className="sticky left-0 border-b border-slate-100 bg-white p-3 text-sm font-bold text-slate-700">
                  <div className="flex items-center justify-between gap-3">
                    <span>{feature}</span>
                    <button
                      type="button"
                      onClick={() => onRemoveFeature(feature)}
                      aria-label={`Remove ${feature} from all plans`}
                      className="shrink-0 rounded-lg px-2 py-1 text-[10px] font-black uppercase tracking-wider text-rose-600 hover:bg-rose-50"
                    >
                      Remove
                    </button>
                  </div>
                </th>
                {plans.map((plan) => {
                  const included = Boolean(featureMatrix[plan.key]?.[feature])
                    && String(featureMatrix[plan.key][feature]).toLowerCase() !== 'false';
                  return (
                    <td key={plan.key} className="border-b border-l border-slate-100 p-3 text-center">
                      <input
                        type="checkbox"
                        checked={included}
                        onChange={(event) => onToggle(plan.key, feature, event.target.checked)}
                        aria-label={`${feature} included in ${plan.name || 'new plan'}`}
                        className="h-4 w-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500"
                      />
                    </td>
                  );
                })}
              </tr>
            )) : (
              <tr>
                <td colSpan={plans.length + 1} className="p-5 text-center text-sm text-slate-500">
                  Add a feature to start comparing plans.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="mt-3 flex gap-2">
        <input
          value={newFeature}
          onChange={(event) => setNewFeature(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              addFeature();
            }
          }}
          aria-label="New feature name"
          placeholder="Add a feature"
          className="min-w-0 flex-1 rounded-xl border border-slate-200 px-4 py-2 text-sm"
        />
        <button
          type="button"
          onClick={addFeature}
          className="rounded-xl bg-slate-100 px-4 py-2 text-xs font-black uppercase tracking-wider text-slate-700"
        >
          Add feature
        </button>
      </div>
    </div>
  );
};

export default PlanFeatureMatrix;
